import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  const [displayedText, setDisplayedText] = useState('');
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [showPage, setShowPage] = useState(false);
  const [email, setEmail] = useState('');
  
  const companyName = 'veyebe';
  const links = [
    { name: 'Product', href: '/product' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
    // { name: 'Blog', href: '/blog' }
  ];

  useEffect(() => {
    // Fade in the page from black
    setTimeout(() => setShowPage(true), 200);

    // Typing animation
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= companyName.length) {
        setDisplayedText(companyName.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTypingComplete(true);
      }
    }, 150);

    return () => clearInterval(typingInterval);
  }, []);

  return (
    <div 
      className={`min-h-screen bg-gradient-to-b from-amber-50 to-white transition-opacity duration-1000 ${
        showPage ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* Hero Section */}
      <div className="flex flex-col items-center justify-center min-h-screen px-6 py-20">
        <div className="max-w-3xl w-full text-center space-y-8">
          {/* Company Name - Typing Effect */}
          <h1 className="text-6xl md:text-7xl font-light text-amber-950 tracking-tight min-h-20">
            {displayedText}
            {!isTypingComplete && (
              <span className="animate-pulse">|</span>
            )}
          </h1>
          
          {/* Description - Fades in after typing */}
          <p 
            className={`text-xl md:text-2xl text-amber-900 font-light leading-relaxed max-w-2xl mx-auto transition-all duration-1000 delay-100 ${
              isTypingComplete ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            building your future, one habit at a time.
          </p>

          {/* Waitlist email submission */}
          {/* <form
            className={`flex flex-col sm:flex-row items-center justify-center gap-4 pt-8 transition-all duration-1000 delay-500 ${
              isTypingComplete ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
            onSubmit={(event) => event.preventDefault()}
          >
            <label className="sr-only" htmlFor="waitlist-email">
              Email address
            </label>
            <input
              id="waitlist-email"
              type="email"
              name="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              placeholder="you@example.com"
              className="w-full sm:w-80 px-4 py-3 text-amber-950 placeholder-amber-700/70 bg-white/80 border border-amber-200 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-300 focus:border-amber-300"
              autoComplete="email"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-amber-900 text-amber-50 font-medium hover:bg-amber-950 transition-colors duration-200"
            >
              Join waitlist
            </button>
          </form> */}
          
          {/* Links - Fade in after typing */}
          <div 
            className={`flex flex-wrap justify-center gap-6 pt-8 transition-all duration-1000 delay-700 ${
              isTypingComplete ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="text-amber-900 hover:text-amber-950 text-lg font-normal transition-colors duration-200 border-b-2 border-transparent hover:border-amber-950 pb-1"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
